import React from 'react';
import { Button, Table, Well, Grid, Row, Col } from 'react-bootstrap';
import _ from 'lodash';
import PropTypes from 'prop-types';

/** React component which render the top menu above the plots */
class SaxsHPLCPlotMenuPanel extends React.Component {
    render() {
        let { buttons } = this.props;

        return <Well style={{ padding: '5px' }}>
            <Grid fluid>
                <Row>
                    <Col xs={12}>
                        {_.map(buttons, button => <span style={{ paddingLeft: button.label === 'Scale' ? '20px' : '5px', paddingRight: '5px' }}> <MenuButton backgroundColor={button.color} label={button.label} onClick={button.onClick} isButtonPressed={button.isButtonPressed} /></span>)}
                    </Col>
                </Row>
            </Grid>
        </Well >
    }
}

export default SaxsHPLCPlotMenuPanel;

SaxsHPLCPlotMenuPanel.proptypes = {
    /* buttons to be displayed in the menu*/
    buttons: PropTypes.array
}

/** React component which renders a button used in the menu */
const MenuButton = (props) => {
    return <Button
        active={props.isButtonPressed === true ? true : false}
        bsSize='small'
        onClick={props.onClick} >
        {props.backgroundColor ? <RectangleColorDiv backgroundColor={props.backgroundColor} height='10' width='10' /> : null}
        <span> {props.label} </span>
    </Button>
}

/** React component which renders a colored rectangle as a div */
const RectangleColorDiv = (props) => {
    let { backgroundColor, height, width } = props;
    return <div style={{ display: 'inline-block', border: '1px solid gray', backgroundColor: backgroundColor, height: String(height) + 'px', width: String(width) + 'px' }} />
}


// WEBPACK FOOTER //
// ./src/components/saxs/SaxsHPLCPlotMenuPanel.js